import { APIError, NetworkError } from './apiRequest';

/**
 * The auth lambda rejects a login when the Stytch user is routed to a different
 * client partition than the host being used. It answers with a 403 and error
 * code `Q`'s message in the body; the code letter itself is not part of the
 * body, so the message is the only signal available to the frontend.
 */
const CROSS_PARTITION_LOGIN_MESSAGE_FRAGMENT = 'correct login host';

export const CROSS_PARTITION_LOGIN_NOTICE =
  'This account is tied to a dedicated Cartwheel workspace. Please sign in from your organization’s Cartwheel login page, or contact support@getcartwheel.com for help.';

export function isCrossPartitionLoginError(
  error: APIError | NetworkError,
): boolean {
  return (
    error instanceof APIError &&
    error.status === 403 &&
    typeof error.message === 'string' &&
    error.message.toLowerCase().includes(CROSS_PARTITION_LOGIN_MESSAGE_FRAGMENT)
  );
}
